/**
 * The location to preselect on the Standorte tab: the only one, when there is
 * exactly one and nothing is selected yet. Anything else leaves the choice to
 * the customer.
 */
export const soleLocationToPreselect = <T extends { id: string }>(
  locations: T[] | null | undefined,
  selected: T | null | undefined,
): T | null => (!selected && locations?.length === 1 ? locations[0] : null);
